export const isDevMode = () => process.env.REACT_APP_FRONT_MODE === 'dev';
